import React, {useEffect} from 'react';
import HeaderTopBar from "../../common/header/HeaderTopBar";
import FooterTwo from "../../common/footer/FooterTwo";
import Copyright from "../../common/footer/Copyright";
import HeaderTwo from "../../common/header/HeaderTwo";
import TawkTo from "tawkto-react";

const Layout = ({children}) => {
    //define your variable before return
    useEffect(() => {
        let tawk = new TawkTo("63fbc0c831ebfa0fe7ef73d2","1gq7mi4tf");

        tawk.onStatusChange((status) =>
        {
            console.log(status)
        })

    }, [])

    return (
        <>
            <HeaderTopBar/>
            <main className="page-wrapper">
                <HeaderTwo btnStyle="round" HeaderSTyle="header-not-transparent"/>
                {children}
                <FooterTwo/>
                <Copyright/>
            </main>
        </>
    )
}
export default Layout;
